import React, {
  cloneElement,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import PropTypes from "prop-types";
import { Dropdown, Icon, Modal } from "semantic-ui-react";

import ConfirmationModal from "components/modals/ConfirmationModal";
import EditContactForm from "routes/entity/forms/EditContact";

const DeleteEntityModal = ({ onConfirmDelete, menuTrigger, noIcon }) => {
  return (
    <ConfirmationModal
      actionDescription="Delete"
      buttonColor="grey"
      onConfirm={onConfirmDelete}
      menuTrigger={menuTrigger}
      icon={noIcon ? null : "trash"}
      warning
    >
      <p>Are you sure you want to delete this Entity?</p>
    </ConfirmationModal>
  );
};

DeleteEntityModal.propTypes = {
  onConfirmDelete: PropTypes.func.isRequired,
  menuTrigger: PropTypes.bool,
  noIcon: PropTypes.bool,
};

const EditContactModal = forwardRef(
  (
    {
      onSuccess = () => {},
      entityId,
      contact: parentContact,
      iconTrigger = false,
      noIcon,
      dialer = false,
      noTrigger = false,
      trigger,
    },
    ref
  ) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [contact, setContact] = useState(parentContact);

    useEffect(() => {
      setContact(parentContact);
    }, [parentContact]);

    const handleOpen = contact => {
      if (contact !== undefined) {
        setContact(contact);
      }
      setModalOpen(true);
    };

    useImperativeHandle(ref, () => ({
      open: handleOpen,
    }));

    const handleClose = () => {
      setModalOpen(false);
    };

    const handleSuccess = async () => {
      await onSuccess(); // maybe-promise
      handleClose();
    };

    const renderTrigger = () => {
      if (noTrigger) {
        return null;
      }
      if (trigger) {
        return cloneElement(trigger, { onClick: () => handleOpen() });
      }
      if (iconTrigger) {
        return (
          <Icon
            name="pencil"
            className="primary"
            link
            onClick={() => handleOpen()}
            style={{
              verticalAlign: dialer ? "-20px" : "-2px",
            }}
          />
        );
      }
      return (
        <Dropdown.Item
          onClick={() => handleOpen()}
          content="Edit"
          icon={noIcon ? null : "edit"}
        />
      );
    };

    return (
      <Modal
        size="small"
        trigger={renderTrigger()}
        open={modalOpen}
        onClose={handleClose}
        closeOnDimmerClick={false}
        closeIcon
        onFocus={e => {
          e.stopPropagation();
        }}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <Modal.Header>Edit Contact</Modal.Header>
        <Modal.Content>
          <EditContactForm
            onSuccess={handleSuccess}
            entityId={entityId ?? contact?.entity_id}
            contact={contact}
          />
        </Modal.Content>
      </Modal>
    );
  }
);

EditContactModal.propTypes = {
  onSuccess: PropTypes.func,
  entityId: PropTypes.number,
  contact: PropTypes.object,
  iconTrigger: PropTypes.bool,
  noIcon: PropTypes.bool,
  dialer: PropTypes.bool,
  noTrigger: PropTypes.bool,
  trigger: PropTypes.element,
};

export { DeleteEntityModal, EditContactModal };
